export const COMMON = {
    YES: 'Yes',
    NO: 'No',
    PRODUCTION: 'Production',
};
export const RESOURCE_GROUP_MSG = "Resource Group Name must end with 'rg' within 3 to 33 chars.";

export const OS_DISK_TYPE = {
    EPHEMERAL: 'Ephemeral',
    MANAGED: 'Managed',
};

export const OS_TYPE = {
    WINDOWS: 'Windows',
    LINUX: 'Linux',
};

export const OS_DISK_SIZE_MIN = 32;
export const OS_DISK_SIZE_MAX = 1024;
export const OS_DISK_SIZE_MIN_MANAGED = 20;
export const OS_DISK_SIZE_MAX_MANAGED = 4095;
export const OS_DISK_SIZE_HELP_TITLE = `OS Disk Size: Minimum ${OS_DISK_SIZE_MIN} GB, Maximum ${OS_DISK_SIZE_MAX} GB`;

export const CLOUD_REQUEST_PREFIXES = ['DEVX', 'RITM'];
export const CLOUD_REQUEST_MAX_DIGITS = 6;
export const CLOUD_REQUEST_PREFIX_LENGTH = 4;
export const CLOUD_REQUEST_MAX_LENGTH = CLOUD_REQUEST_PREFIX_LENGTH + CLOUD_REQUEST_MAX_DIGITS;

export const NODE_COUNT_MIN = 1;
export const NODE_COUNT_MAX = 100;
export const NODE_COUNT_HELP_TITLE = 'Node Count: Initial number of nodes in the pool (1-100)';

export const MIN_NODE_MIN = 0;
export const MIN_NODE_MAX = 100;
export const MIN_NODE_HELP_TITLE = 'Min Node: Minimum number of nodes for auto-scaling (0-100)';

export const MAX_NODE_MIN = 1;
export const MAX_NODE_MAX = 1000;
export const MAX_NODE_HELP_TITLE = 'Max Node: Maximum number of nodes for auto-scaling (1-1000)';

export const MAX_PODS_DEFAULT = 110;
export const MAX_PODS_MAX = 110;
export const MAX_PODS_HELP_TITLE = 'Max Pods: Maximum pods per node (110)';

export default {};
